<template>


    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click.native="dismiss()">
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{translater.__('Edit Route - {0}', 'routes', displayName)}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>

            </v-toolbar-items>
        </v-toolbar>
        <v-breadcrumbs :items="items">
            <v-icon slot="divider">chevron_right</v-icon>


        </v-breadcrumbs>

    </v-card>


</template>
<script>

    export default {
        name: 'RoutesSelectedLocation',
        data() {
            return {
                notifications: [],
                sound: undefined,
                widgets: [],


            }
        },


        mounted() {
            /* this is here, 'cause there's no way to set new z-index value the "vue way" and the default z-index is wrong and thus the dialog gets left behind the map
            document.getElementsByClassName('v-dialog__content')[0].style.zIndex = 3000;*/

            /*let items = Array.from(document.getElementsByClassName('v-breadcrumbs__item'))
            items.forEach((i) => {
                i.addEventListener('click', (e) => {
                    console.log("clicked breadcrumbs")
                })
            }) */


        },

        methods: {
            dismiss() {
                this.$store.dispatch('drawer/setForm', 'addRoute')
                window.vm.$emit('hideLocations', 'locations');
                this.dialog = !this.dialog;

            },


        },

        computed: {
            dialog: {
                get() {
                    return this.$store.getters['locations/showSelectedLocationDialog'];
                },

                set(value) {
                    if (!value) {
                        window.vm.$emit('flushFeatures');
                    }
                    this.$store.dispatch('locations/setShowSelectedLocationDialog', value);
                }
            },

            location: {
                get() {
                    let l = this.$store.getters['locations/location'].location;

                    return l
                }
            },

            translater: {
                get() {
                    return this.$store.getters['translate/translater'];
                }
            },

            items: {
                get() {
                    let items = this.$store.getters['breadcrumbs/items'];
                    //console.log("####### items", items)
                    return items;
                }
            },

            displayName: {
                get() {
                    let displayName = '';
                    let route = this.$store.getters['routes/route'];
                    if (typeof route !== 'undefined') {
                        displayName = route.displayName;
                    }

                    return displayName;
                }
            }


        }


    }
</script>


